module.exports = __webpack_public_path__ + "static/media/rss.42f801c9.svg";